/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import { Component } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { IPurchase } from '../purchases.interface';
import { PurchaseDocumentsService } from '../purchases-document.service';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { getTagColor } from '../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-purchases',
  templateUrl: './purchases.component.html'
})
export class PurchasesDocumentComponent extends TableActionsTemplate {
  idDocument: number;

  constructor(private serviceBase: PurchaseDocumentsService) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Reporte de Compras',
      columns: [
        {
          header: 'Fecha Facturación',
          field: 'fechaFacturacion',
          tooltipField: 'fechaFacturacionTooltip'
        },
        { header: 'Tipo Documento', field: 'typeVoucherId', tag: 'tagStatus' },
        { header: 'Serie Número Factura', field: 'numberDocument' },
        { header: 'RUC', field: 'providerRuc' },
        { header: 'Proveedor', field: 'providerName' },

        
        { header: 'Producto', field: 'descriptionItem' },
        { header: 'Cantidad', field: 'quantityItem' },
        { header: 'Precio Compra', field: 'purcharsePriceItem', pipe: 'Currency' },
        { header: 'Importe', field: 'totItem', pipe: 'Currency' },


        { header: 'Moneda', field: 'currency' },
        { header: 'IGV', field: 'igv', pipe: 'Currency' },
        { header: 'Monto Total', field: 'amount', pipe: 'Currency' },
        { header: 'Tipo de Compra', field: 'purchaseType' },
        { header: 'Lote', field: 'lotItem' },
        {
          header: 'Fecha Operación',
          field: 'operationDate',
          tooltipField: 'operationDateTooltip'
        }
        // { header: 'Estado', field: 'state' },
        // {
        //   header: 'Fecha de Registro de Facturacion',
        //   field: 'registrationDate'
        // },
        // { header: 'Estado', field: 'purchaseState' }
      ],
      exportData: true,
      filterColumns: true
    };

    this.table.actions = [
      {
        name: 'see-details',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      }
    ];

    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPurchase[]) => {
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(item.typeVoucherId);
          item.fechaFacturacionTooltip = this.formatDateTime(item.invoiceDate);
          item.fechaFacturacion = this.formatDateOnly(item.invoiceDate);
          item.operationDateTooltip =
            item.operationDate || this.formatDateTime(item.updatedAt);
          item.operationDate = this.formatDateOnly(item.operationDateTooltip);
          return item;
        });
        this.table.data = data;
      });
  }

  private formatDateOnly(value?: string): string {
    if (!value) return '';
    if (/^\d{2}\/\d{2}\/\d{4}/.test(value)) return value.substring(0, 10);

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return new Intl.DateTimeFormat('es-PE', {
      timeZone: 'America/Lima',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  }

  private formatDateTime(value?: string): string {
    if (!value) return '';
    if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(value)) {
      return value;
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return new Intl.DateTimeFormat('es-PE', {
      timeZone: 'America/Lima',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })
      .format(date)
      .replace(',', '');
  }

  async onReciveAction(event: IEventAction) {
    if (event) {
      const { data, action } = event;
      if (action === 'see-details') {
        this.idDocument = data.id;
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
